export default __webpack_public_path__ + "static/media/Spectra_logo_vert.2f0d723a.png";